import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from '../contexts/ThemeContext';
import LaporLemburForm from '../components/forms/LaporLemburForm';
import { useNavigate } from 'react-router-dom';

const TeacherLaporLemburPage = () => {
  const { darkMode } = useContext(ThemeContext);
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(true);

  const handleCloseForm = () => {
    setShowForm(false);
    navigate('/teacher');
  };

  return (
    <PageContainer>
      <PageHeader>
        <BackButton onClick={() => navigate('/teacher')}>← Kembali</BackButton>
        <h1>Formulir Laporan Lembur</h1>
        <p>Buat laporan lembur untuk kegiatan tambahan</p>
      </PageHeader>
      
      <FormContainer>
        {showForm && (
          <LaporLemburForm 
            onClose={handleCloseForm}
          />
        )}
      </FormContainer>
    </PageContainer>
  );
};

// Styled Components
const PageContainer = styled.div`
  padding: 1.5rem;
  max-width: 800px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem 0.5rem;
  }
`;

const PageHeader = styled.div`
  margin-bottom: 2rem;
  
  h1 {
    font-size: 1.75rem;
    font-weight: 600;
    color: var(--text-dark);
    margin-bottom: 0.5rem;
  }
  
  p {
    color: var(--text-light);
  }
`;

const BackButton = styled.button`
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text-dark);
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 1rem;
  transition: all 0.2s;
  
  &:hover {
    background-color: var(--background-light);
  }
`;

const FormContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export default TeacherLaporLemburPage;